export const ROLE_PERMISSIONS = {
  SUPERADMIN: ['view', 'edit', 'delete', 'administer-locations', 'administer-countries', 'view-material-checks'],
  ADMIN: ['view', 'edit', 'delete', 'view-material-checks'],
  VIEWER: ['view', 'view-material-checks'],
  EMPLOYEE: ['create-material-checks'],
};
